<template>
  <section class="mt-2" v-if="settings">
    <b-overlay :show="loading" rounded="sm">

      <div class="info-header mt-2">{{ $t("STATE") }}</div>
      <div class="ml-2 mt-2">
        <b-form-checkbox
          v-model="settings.enabled"
          :value="true"
          switch
          :unchecked-value="false"
        >{{ $t('STATUS_ACTIVE') }}</b-form-checkbox>
      </div>

      <div class="info-header mt-4">{{ $t("ENFORCE_SUBJECT") }}</div>
      <div class="ml-2 mt-2">
        <b-form-input trim v-model="settings.subject"></b-form-input>

        <b-form-checkbox
          v-if="settings.subject"
          v-model="settings.unlock_subject"
          switch
          :value="true"
          :unchecked-value="false"
          >{{ $t("USER_CAN_UNLOCK") }}</b-form-checkbox
        >
      </div>

      <div class="info-header mt-4">{{ $t("ENFORCE_EMAIL_BODY") }}</div>
      <div class="ml-2">
        <b-form-textarea v-model="settings.email_body"></b-form-textarea>

        <b-form-checkbox
          v-if="settings.email_body"
          v-model="settings.unlock_email_body"
          switch
          :value="true"
          :unchecked-value="false"
          >{{ $t("USER_CAN_UNLOCK") }}</b-form-checkbox
        >
      </div>

      <div class="info-header mt-4">{{ $t("MISC") }}</div>
      <div class="ml-2 mt-2">
        <b-form-checkbox
          class="mt-2"
          v-model="settings.reply"
          switch
          :value="true"
          :unchecked-value="false"
        >
          {{ $t("MESSAGES.REQUEST_RESPONSE") }}</b-form-checkbox
        >

        <b-form-checkbox
          class="mt-2"
          v-model="settings.reply_default"
          switch
          :value="true"
          :unchecked-value="false"
          >{{ $t("MESSAGES.REQUEST_RESPONSE_SETTINGS") }}</b-form-checkbox
        >
      </div>

      <hr class="p-0 m-0 mt-4 mb-2" />

      <b-button variant="primary" class="btn-fill" @click="updateSettings">{{
        $t("SAVE")
      }}</b-button>
    </b-overlay>
  </section>
</template>
<script>
export default {
  props: {
    functionbox_uuid: {
      default: "",
      type: String,
    },
    organisation_uuid: {
      default: "",
      type: String,
    }
  },
  data() {
    return {
      settings: null,
      loading: false,
    };
  },
  methods: {
    getSettings() {
      let self = this;
      self.loading = true;
      this.$http
        .post(this.user.hostname + "/settings/get", {
          setting: "SefosMessage",
          organisation_uuid: this.organisation_uuid,
          functionbox_uuid: this.functionbox_uuid,
        })
        .then(function (result) {
          self.settings = result.data;
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH"));
        });
    },
    updateSettings() {
      let self = this;
      self.loading = true;
      this.$http
        .post(this.user.hostname + "/settings/save", self.settings)
        .then(function () {
          self.$noty.info(self.$t("SAVED"));
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
          self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
        });
    },
  },
  mounted: function () {
    this.getSettings();
  },
};
</script>
<style></style>
